import {Component} from "react";
import styled from "styled-components";
import ArrowButton from "basicComponents/ArrowButton/ArrowButton";
import GlobalMessages from "messages/messages";
import {FormattedMessage} from "react-intl";
import * as PropTypes from "prop-types";

export default class DurationPicker extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    duration: PropTypes.number.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    noLoop: PropTypes.bool,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    min: 15,
    max: 180,
  };

  handleUpClicked = () => {
    const newDuration = this.props.duration + 5;
    if (newDuration > this.props.max) {
      if (!this.props.noLoop) {
        this.props.onChange(this.props.min);
      }
    } else {
      this.props.onChange(newDuration);
    }
  };

  handleDownClicked = () => {
    const newDuration = this.props.duration - 5;
    if (newDuration < this.props.min) {
      if (!this.props.noLoop) {
        this.props.onChange(this.props.max);
      }
    } else {
      this.props.onChange(newDuration);
    }
  };

  isUpDisabled() {
    return this.props.noLoop && this.props.duration >= this.props.max;
  }

  isDownDisabled() {
    return this.props.noLoop && this.props.duration <= this.props.min;
  }

  render() {
    return (
      <Wrapper>
        <LabelWrapper >
          <FormattedMessage {...GlobalMessages.duration} />
        </LabelWrapper>
        <ContentDuration>
          <ButtonWrapper>
            <ArrowButton
              disabled={this.isDownDisabled()|| this.props.loading}
              left
              onClick={this.handleDownClicked}
            />
          </ButtonWrapper>
          <TimeWrapper>
            {`${this.props.duration} `}
            <FormattedMessage {...GlobalMessages.minutesSmall} />
          </TimeWrapper>
          <ButtonWrapper>
            <ArrowButton
              disabled={this.isUpDisabled()|| this.props.loading}
              right
              onClick={this.handleUpClicked}
            />
          </ButtonWrapper>
        </ContentDuration>
      </Wrapper>
    );
  }
}

const LabelWrapper = styled.div`
  position: absolute;
  left: 20;
  display: block;
  z-index: 1;
  color: rgba(0,0,0,0.56);
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: no-wrap;
  padding: 0 10px;
  max-width: 100%;
  transform: translate(20%, -50%);
  background-color: white;
`

const TimeWrapper = styled.div`
  flex : 1;
  display: flex;
  justify-content: center;
  margin-left: 3px;
  margin-right: 3px;
`;

const Wrapper = styled.div`
  position: relative;
`;

const ContentDuration = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 5px;
  padding-top: 5px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 25px;
`;

const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`
